export const CONVERSATION_LIST_PAGE_SIZE = 25;

export const CONVERSATION_LIST_LOAD_MORE_PAGE_SIZE = 75;

export const CONVERSATION_LIST_MAX_SIZE = 100;

export const CONVERSATION_LIST_PAGINATION_EXPERIMENT = 'rovo_chat_conversation_list_pagination';

export const ACTION_EXECUTION_FAILED = 'Action execution failed';
